import styled from 'styled-components';
import { VideoComponent } from '@elfsight/widget-media-video/src/video-component/video-component';
import { useIsMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

export const Video = () => {
  const { videoUrl, videoSizeMobile, videoSize } = useSettings();

  const isMobile = useIsMobile();

  if (!videoUrl) return;

  return (
    <Container
      onClick={(e) => e.stopPropagation()}
      _width={isMobile ? videoSizeMobile : videoSize}
    >
      <VideoComponent mode="popup" videoUrl={videoUrl} />
    </Container>
  );
};

const Container = styled.div<{ _width: number }>`
  width: ${({ _width }) => _width}px;
`;
